import { render } from "./soadiff.vue?vue&type=template&id=0cd7eda7&scoped=true"
import script from "./soadiff.js?vue&type=script&lang=js"
export * from "./soadiff.js?vue&type=script&lang=js"

import "./soadiff.vue?vue&type=style&index=0&id=0cd7eda7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd7eda7"]])

export default __exports__